<template>
  <div class="new-release" :class="{'new-release--mobile': deviceType === 'mobile'}">
    <div class="new-release__container">
      <!-- 标题栏 -->
      <div class="new-release__header">
        <h2 class="new-release__title">New Release Rank</h2>
        <a v-if="!loading && cars.length > 0" class="new-release__view-more" :href="getHrefForAll()">
          <span>View More</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10" fill="none">
            <path d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z" fill="#e2372d"/>
          </svg>
        </a>
        <div v-else class="new-release__view-more-skeleton"></div>
      </div>

      <!-- 骨架屏 -->
      <div v-if="loading || cars.length === 0" class="new-release__skeleton">
        <div class="new-release__grid">
          <div v-for="n in 4" :key="`skeleton-${n}`" class="new-release__card new-release__card--skeleton">
            <div class="new-release__card-img-wrapper">
              <div class="new-release__skeleton-img"></div>
              <div class="new-release__card-badge">
                <div class="new-release__card-logo-box new-release__skeleton-logo"></div>
                <div class="new-release__card-date">
                  <div class="new-release__skeleton-date-icon"></div>
                  <div class="new-release__skeleton-date-text"></div>
                </div>
              </div>
            </div>
            <div class="new-release__card-content">
              <div class="new-release__skeleton-title"></div>
              <div class="new-release__skeleton-brand"></div>
              <div class="new-release__card-tags">
                <div class="new-release__card-tag">
                  <div class="new-release__skeleton-tag-icon"></div>
                  <div class="new-release__skeleton-tag-text"></div>
                </div>
                <div class="new-release__card-tag">
                  <div class="new-release__skeleton-tag-icon"></div>
                  <div class="new-release__skeleton-tag-text"></div>
                </div>
                <div class="new-release__card-tag">
                  <div class="new-release__skeleton-tag-icon"></div>
                  <div class="new-release__skeleton-tag-text"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 实际内容 -->
      <div v-else class="new-release__grid">
        <a v-for="(car, index) in cars" :key="index" class="new-release__card" :href="getHrefForDetail(car)">
          <!-- 图片和徽章 -->
          <div class="new-release__card-img-wrapper">
            <img :src="car.image" class="new-release__card-img" :alt="car.model">
            <div class="new-release__card-badge">
              <div class="new-release__card-logo-box">
                <img :src="car.logo" class="new-release__card-logo" :alt="car.brand">
              </div>
              <div class="new-release__card-date">
                <img src="@/assets/calendar.svg" class="new-release__card-date-icon" alt="date">
                <span>{{ car.releaseTime }}</span>
              </div>
            </div>
          </div>

          <!-- 文字信息 -->
          <div class="new-release__card-content">
            <h3 class="new-release__card-title">{{ car.model }}</h3>
            <p class="new-release__card-brand">{{ car.brand }}</p>

            <!-- 标签组 -->
            <div class="new-release__card-tags">
              <div class="new-release__card-tag">
                <img src="@/assets/car-type.svg" alt="type">
                <span>{{ car.bodyType }}</span>
              </div>
              <div class="new-release__card-tag">
                <img src="@/assets/body-type.svg" alt="purpose">
                <span>{{ car.category }}</span>
              </div>
              <div class="new-release__card-tag">
                <img src="@/assets/homehero/Budget.svg" alt="price">
                <span>{{ car.price }}</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <AdComponent v-if="$global.isValidAdConfig(adsensConfig?.home_5)"
        ref="ads-home-5" class="ads-insert-full" :ads="adsensConfig?.home_5"
        :showDebug="showDebug" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'

export default {
  name: 'CarNewRelease',
  components: {
    AdComponent
  },
  data () {
    return {
      cars: [],
      loading: true
    }
  },
  computed: {
    ...mapGetters(['deviceType', 'domainConfig', 'adsensConfig', 'showDebug'])
  },
  mounted () {
    this.fetchNewRelease();
  },
  methods: {
    async fetchNewRelease () {
      this.loading = true;
      try {
        const themeFilters = this.domainConfig?.themeFilters || {};
        const webIndex = this.domainConfig?.webIndex || 1;
        const params = { ...themeFilters, webIndex };
        const res = await this.$global.server.getRecommendedNewReleaseRank(params);
        if (res.code === 200) {
          this.cars = (res.data || []).slice(0, 4).map(item => {
            const photos = item.photos ? item.photos.split(',') : [];
            let releaseTime = item.marketTime || item.year || '-';
            if (releaseTime && releaseTime.length >= 7) {
              releaseTime = releaseTime.substring(0, 7).replace('-', '.');
            }
            return {
              id: item.id,
              model: item.name,
              brand: item.brand,
              logo: item.logoUrl,
              image: item.cover || photos[0],
              releaseTime: releaseTime,
              bodyType: item.type || '-',
              category: item.purpose || '-',
              price: this.formatPrice(item.leastPrice, item.mostPrice) || '-'
            };
          });
        }
      } catch (error) {
        console.error('[CarNewRelease] fetch error:', error);
      } finally {
        this.loading = false;
      }
    },
    formatPrice (least, most) {
      if (!least && !most) return null;
      const fmt = (n) => n ? '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
      if (least && most) return `${fmt(least)}-${fmt(most)}`;
      return least ? `>${fmt(least)}` : `<${fmt(most)}`;
    },
    getHrefForAll () {
      const channel = this.$route.params.channel;
      return channel ? `/${channel}/car-list` : '/car-list';
    },
    getHrefForDetail (car) {
      const channel = this.$route.params.channel;
      const name = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      return channel ? `/${channel}/cars/${name}/${car.id}` : `/cars/${name}/${car.id}`;
    }
  }
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.new-release {
	background: #000;
	padding: rem(60) rem(180);
	width: 100%;
	box-sizing: border-box;

	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(30);
	}

	&__title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(24);
		font-weight: 800;
		margin: 0;
	}

	&__view-more {
		display: flex;
		align-items: center;
		gap: rem(12);
		text-decoration: none;
		span {
			color: #e2372d;
			font-family: 'Inter-ExtraBold', sans-serif;
			font-size: rem(14);
			font-weight: 800;
		}
	}

	&__grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(20);
	}

	&__card {
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		overflow: hidden;
		text-decoration: none;
		transition: all 0.3s ease;
		display: flex;
		flex-direction: column;
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);

		&:hover {
			transform: translateY(-5px);
			border-color: rgba(226, 55, 45, 0.5);
		}
	}

	&__card-img-wrapper {
		position: relative;
		height: rem(148);
		padding: rem(8);
	}

	&__card-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(12);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}

	&__card-badge {
		position: absolute;
		top: rem(8);
		left: rem(8);
		display: flex;
		align-items: flex-start;
		background: transparent;
	}

	&__card-logo-box {
		width: rem(32);
		height: rem(32);
		background: #fff;
		border-radius: rem(12) 0 rem(12) 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: rem(4);
		box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.32);
	}

	&__card-logo {
		width: 80%;
		height: 80%;
		object-fit: contain;
	}

	&__card-date {
		background: #e2372d;
		border-radius: 0 0 rem(12) 0;
		padding: rem(4) rem(8);
		display: flex;
		align-items: center;
		gap: rem(4);
		height: rem(20);
		box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.32);

		span {
			color: #fff;
			font-size: rem(12);
			font-weight: 400;
		}
	}

	&__card-date-icon {
		width: rem(12);
		height: rem(12);
		filter: brightness(0) invert(1);
	}

	&__card-content {
		padding: rem(12) rem(16) rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(8);
	}

	&__card-title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(16);
		font-weight: 800;
		margin: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__card-brand {
		color: rgba(255, 255, 255, 0.5);
		font-size: rem(12);
		margin: 0;
	}

	&__card-tags {
		display: flex;
		flex-direction: column;
		gap: rem(6);
		margin-top: rem(4);
	}

	&__card-tag {
		background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 100%);
		border-radius: rem(12);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: rem(10) rem(16);
		display: flex;
		align-items: center;
		gap: rem(12);

		img {
			width: rem(16);
			height: rem(16);
			// filter: brightness(0) invert(1);
		}

		span {
			color: #ffffff;
			font-size: rem(12);
			font-weight: 500;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	// 骨架屏样式
	&__view-more-skeleton {
		width: rem(100);
		height: rem(24);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__card--skeleton {
		pointer-events: none;
		cursor: default;
	}

	&__skeleton-img {
		width: 100%;
		height: 100%;
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(12);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-logo {
		background: rgba(255, 255, 255, 0.1) !important;
		animation: skeleton-loading 1.5s ease-in-out infinite;
		img {
			display: none;
		}
	}

	&__skeleton-date-icon {
		width: rem(12);
		height: rem(12);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(2);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-date-text {
		width: rem(40);
		height: rem(12);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(2);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-title {
		width: 70%;
		height: rem(18);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		margin-bottom: rem(8);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-brand {
		width: 50%;
		height: rem(14);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-tag-icon {
		width: rem(16);
		height: rem(16);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(2);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-tag-text {
		width: rem(40);
		height: rem(12);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(2);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}
}

@keyframes skeleton-loading {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.4;
	}
	100% {
		opacity: 1;
	}
}

// PC端
.detect_deviece_pc, .detect_deviece_desktop {
	.new-release {
		padding: rem(60) rem(180);
		&__grid {
			grid-template-columns: repeat(4, 1fr);
		}
	}
}

// 移动端
.detect_deviece_mobile {
	.new-release {
		padding: rem(60) 0 rem(60) rem(16);
		&__header {
			padding-right: rem(16);
		}
		&__grid {
			display: flex;
			overflow-x: auto;
			gap: rem(12);
			padding-right: rem(20);
			&::-webkit-scrollbar {
				display: none;
			}
		}
		&__card {
			min-width: rem(252);
			flex-shrink: 0;
		}
	}
}
</style>
